/**
 * Bara de 4 pasi a inscrierii ("Pasul N din 4"). Tiparul vizual e cel deja livrat, duplicat
 * inline in `CadruPasVideo.tsx:52-58` (pasul 3) si `ProtocolPage.tsx` (pasul 4) -- extras aici
 * doar pentru cei doi consumatori NOI din p8 (`InregistrareCodPage`, pasul 1;
 * `SchoolRequestFormPage`, pasul 2, ambele sub `VITE_INREGISTRARE_COD`), ca sa nu se
 * dubleze inca o data acelasi markup. Cele doua locuri deja livrate NU sunt atinse aici --
 * extragerea lor e curatenie optionala, nu ceruta de p8 (directia S1, 2026-09-11).
 */
interface BaraPasiInscriereProps {
  pasCurent: 1 | 2 | 3 | 4;
}

const TOTAL_PASI = 4;

export function BaraPasiInscriere({ pasCurent }: BaraPasiInscriereProps) {
  return (
    <div className="px-4 pt-3">
      <div className="flex gap-1.5">
        {Array.from({ length: TOTAL_PASI }, (_, index) => {
          const pas = index + 1;
          const culoare = pas < pasCurent ? 'bg-magenta' : pas === pasCurent ? 'bg-lime-accent' : 'bg-muted';
          return <i key={pas} className={`h-1 flex-1 rounded-sm ${culoare}`} />;
        })}
      </div>
      <p className="m-0 pt-2 text-smaller uppercase tracking-wider text-gray-600">
        Pasul {pasCurent} din {TOTAL_PASI}
      </p>
    </div>
  );
}
